"use strict";

var React = require('react/addons');
var Fluxxor = require('fluxxor');
var _ = require('underscore');

var GuestStore = Fluxxor.createStore({
  actions: {
    CHANGE_GUEST_NUMBER: 'onGuestNumberChange'
  },

  initialize: function (options) {
    this.setMaxListeners(0);
    this.state = _.clone(options);
  },

  onGuestNumberChange: function(payload) {
    this.state = React.addons.update(this.state, {
      numberOfGuests: {$set: payload}
    });

    this.emit('change');
  },

  getState: function () {
    return this.state;
  },

  getNumberOfGuests: function () {
    return this.state.numberOfGuests || 1;
  }
});

module.exports = GuestStore;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/stores/guest.js
 **/